export function SectionHeading({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`section-heading section-heading-${align}`} data-reveal>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="section-h2">{title}</h2>
      {subtitle && <p className="section-sub">{subtitle}</p>}
    </div>
  );
}
